import { render, staticRenderFns } from "./related-items-list.vue?vue&type=template&id=536016d8&"
import script from "./related-items-list.vue?vue&type=script&lang=ts&"
export * from "./related-items-list.vue?vue&type=script&lang=ts&"
import style0 from "./related-items-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports